import React, { lazy } from 'react'
import { Route } from 'react-router'
import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const TrainingSkylegsRecordsRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--training--skylegs-archive']}>
    <Route index element={<Index />} />
  </SubRouter>
))
